import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { LoginService } from '@intranet/modules/login/login.service';
import { UserService } from '@intranet/modules/users/user.service';
import { Currency } from '@intranet/modules/finance';
import { FinanceService } from '@intranet/modules/finance';

@Component({
    selector: 'admin-currency',
    templateUrl: './admin-currency.component.html',
    styleUrls: ['./admin-currency.component.scss'],
})
export class AdminCurrencyComponent implements OnInit {
    isAdd: boolean;
    currencyToEdit: Currency | undefined;
    showEdit: boolean;
    currencies: Currency[] = [];
    error: any;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private financeService: FinanceService,
        private loginService: LoginService,
        private userService: UserService
    ) {}

    ngOnInit(): void {
        this.getCurrencies();
    }

    getCurrencies(): void {
        this.financeService.getCurrencies().subscribe({
            next: (currencies) => {
                console.log(currencies);
                this.currencies = currencies;
                this.cancelEdit();
            },
            error: (error) => (this.error = error),
        });
    }

    addNewCurrency() {
        let order =
            this.currencies.reduce((max, cur) => {
                return Math.max(max, cur.order);
            }, 0) + 1;
        this.currencyToEdit = {
            currencyId: 0,
            autoCalculateTo: true,
            fromSterling: 1,
            code: '',
            name: '',
            order: order,
            symbol: '',
            toSterling: 1,
        };

        this.showEdit = true;
        this.isAdd = true;
    }

    editCurrency(currency: Currency) {
        this.isAdd = false;
        this.currencyToEdit = currency;
        this.showEdit = true;
    }

    cancelEdit() {
        this.showEdit = false;
        this.currencyToEdit = undefined;
    }

    calculateFrom() {
        if (
            this.currencyToEdit &&
            this.currencyToEdit.autoCalculateTo &&
            this.currencyToEdit.fromSterling
        ) {
            this.currencyToEdit.toSterling =
                1.0 / this.currencyToEdit.fromSterling;
        }
    }

    onSubmit() {
        if (this.currencyToEdit) {
            this.financeService
                .addOrUpdateCurrency(this.currencyToEdit)
                .subscribe({
                    next: (r) => {
                        this.getCurrencies();
                    },
                    error: (error) => (this.error = error),
                });
        }
    }
}
